import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'properties',
  namespace: 'property',
  mountedUrl: '/properties',
  title: 'Properties',
  columns: [
    { attribute: 'name' },
    { label: 'source', value: (o) => o.source_channel ? o.source_channel.name : 'Local', sortable: false },
    { attribute: 'group.name', label: 'group' },
    { attribute: 'zone.name', label: 'location' },
    { attribute: 'surface' },
    { attribute: 'nb_bedrooms', label: 'bedrooms' },
    { attribute: 'nb_bathrooms', label: 'bathrooms' },
    { attribute: 'active', value: (obj) => obj.active ? <i className="fas fa-check" /> : null },
    // { attribute: 'node_uid', sortable: false },
  ],
  useQuickSearch: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/containers/Listing.jsx